export default __webpack_public_path__ + "static/media/slicing-bread.969b0758.mp3";